exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-5d52594e]{font-weight:700;color:var(--dark-color)}.uploadBtn[data-v-5d52594e]{border:1px solid var(--dark-color);color:var(--dark-color)}.uploadBtn[data-v-5d52594e]:hover{background-color:var(--dark-color);color:var(--white-color)}.test[data-v-5d52594e]{display:none}@media (min-width:1200px){.test[data-v-5d52594e]{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d52594e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/awards/UpdateAward.vue
// module id = 377
// module chunks = 0